var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9667 8.00063C13.9667 8.75255 13.8518 9.43381 13.668 10.0462C13.5688 10.3769 13.7564 10.7253 14.0871 10.8245C14.4178 10.9237 14.7662 10.7361 14.8654 10.4054C15.0817 9.68438 15.2168 8.88221 15.2168 8.00063C15.2168 3.97692 11.9834 0.708329 7.98283 0.708329C3.98217 0.708329 0.748834 3.97692 0.748834 8.00063C0.748834 12.0244 3.98217 15.293 7.98283 15.293C9.47071 15.293 10.8585 14.8363 12.0077 14.061C12.2939 13.868 12.3694 13.4795 12.1763 13.1933C11.9832 12.9071 11.5948 12.8316 11.3086 13.0247C10.3576 13.6662 9.21179 14.0429 7.98283 14.0429C4.68279 14.0429 1.99895 11.3442 1.99895 8.00063C1.99895 4.65708 4.68279 1.95844 7.98283 1.95844C11.2828 1.95844 13.9667 4.65708 13.9667 8.00063Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8993 8.70302C16.7114 8.41344 16.3243 8.33093 16.0347 8.5188L14.4024 9.57755L13.3418 7.9298C13.155 7.63952 12.7682 7.55572 12.4779 7.74253C12.1876 7.9294 12.1038 8.31618 12.2907 8.60641L13.6908 10.7816C13.7807 10.9213 13.9225 11.0195 14.085 11.0544C14.2474 11.0893 14.4171 11.0581 14.5565 10.9677L16.715 9.56759C17.0046 9.37973 17.0871 8.99264 16.8993 8.70302Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.df3089951018ea0fb833499cbbd363a4.svg";
export { ForwardRef as ReactComponent };